document.addEventListener('DOMContentLoaded', function() {
    let form = document.getElementById('ContactForm');
    let requiredFields = form.querySelectorAll('.field__input.required');
    let errorMessages = form.querySelectorAll('.error-message-contact-form');
  
    form.addEventListener('submit', function(event) {
      let isValid = true; 
  
      requiredFields.forEach(function(field, index) {
        let errorMessage = errorMessages[index];
  
        if (field.value.trim() === '') {
          errorMessage.style.display = 'block';
          isValid = false; 
        } else {
          errorMessage.style.display = 'none';
        }
      });
  
      if (!isValid) {
        event.preventDefault();
        return false;
      }
    });
  });